/**
 * SettingsLink — "Ajustes → Datos" como enlace que abre esa pestaña.
 *
 * El prefijo sale de `nav.settings` — el mismo nombre que el usuario ve en el
 * menú lateral ("Configuración"), no el título en mayúsculas de la pantalla.
 *
 * Se usa en cualquier mensaje que mande a Ajustes. El nombre de la pestaña lo
 * pone el i18n y el destino `settingsTabPath`: si mañana Datos se llama de otra
 * forma o se parte en dos, el enlace sigue funcionando y diciendo la verdad.
 * Antes esto se escribía a mano en el texto y se pudrió en silencio.
 */
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { settingsTabPath, settingsTabLabelKey, type SettingsTabId } from '../../lib/settingsTabs.js';

export function SettingsLink({ tab }: { tab: SettingsTabId }) {
  const { t } = useTranslation();
  return (
    <Link
      to={settingsTabPath(tab)}
      style={{ color: 'var(--evo-cyan)', textDecoration: 'none', whiteSpace: 'nowrap' }}
    >
      {t('nav.settings')} → {t(settingsTabLabelKey(tab))}
    </Link>
  );
}

/** El mismo rótulo sin enlace — para un toast, donde no se puede navegar. */
export function useSettingsTabLabel(tab: SettingsTabId): string {
  const { t } = useTranslation();
  return `${t('nav.settings')} → ${t(settingsTabLabelKey(tab))}`;
}
